import React from 'react';
import { SectionHeading } from './SectionHeading';
import { gallery } from '../data/site';
const spanClass: Record<string, string> = {
  wide: 'sm:col-span-2 sm:row-span-2',
  tall: 'sm:row-span-2',
  normal: ''
};
export function Gallery() {
  return <section id="work" className="relative bg-steel-950 py-20 lg:py-28" data-id="element-93" data-mp="3ia53cmvg1tqc">
      <div className="relative mx-auto max-w-[1400px] px-5 lg:px-10" data-id="element-94" data-mp="3defyc40nnkmn">
        <SectionHeading eyebrow="Our Work" title={<>
              The bead tells
              <br data-id="element-96" data-mp="2kpsac0oiuh5e" />
              the whole story
            </>} description="Every job leaves the shop clean, square, and coated. Take a look at the joints we're proud of." data-id="element-95" data-mp="2pmsh6dt73nxk" />

        <div className="mt-14 grid auto-rows-[220px] grid-cols-1 gap-4 sm:grid-cols-3 lg:auto-rows-[240px] lg:grid-cols-4" data-id="element-97" data-mp="2ulvch6jdifsc">
          {gallery.map(item => <figure key={item.title} className={`group relative overflow-hidden border border-white/10 ${spanClass[item.span]}`} data-id="element-98" data-mp="21y9c075fzr9p">
              <img src={item.src} alt={item.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.06]" data-id="element-99" data-mp="wb4cjcql1c58" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-80" aria-hidden="true" data-id="element-100" data-mp="153fzupqegjgz" />
              <figcaption className="absolute inset-x-0 bottom-0 p-5" data-id="element-101" data-mp="ddl1y4oh7lgp">
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-brand-light" data-id="element-102" data-mp="hdvha7y5ro88">
                  {item.category}
                </div>
                <div className="mt-1.5 font-display text-lg font-semibold uppercase tracking-tight text-white" data-id="element-103" data-mp="mbdh98u76t43">
                  {item.title}
                </div>
              </figcaption>
            </figure>)}
        </div>

        <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.18em] text-steel-500" data-id="element-104" data-mp="3tv8jym0l8rel">
          Placeholder captions — swap in real project details
        </p>
      </div>
    </section>;
}